module.exports = new __parcel__URL__("vibe-4.9854db25.json").toString();